import { SetupStatus } from '@deizi/shared';
import { useQuery } from '@tanstack/react-query';
import { api } from './api';

export const setupKey = ['setup'] as const;

export function useSetupStatus() {
  return useQuery({ queryKey: setupKey, queryFn: () => api.get('/setup/status', SetupStatus) });
}

/** Wizard step (1-based) that fixes a missing checklist item. */
export const STEP_FOR_ITEM = { costs: 2, printer: 3, filament: 4, channel: 5 } as const;

export const SETUP_ITEM_LABELS = {
  costs: { title: 'Tarifa de energia e custos', todo: 'CELESC já vem sugerida' },
  printer: { title: 'Impressora', todo: 'Modelo, preço e vida útil' },
  filament: { title: 'Um filamento com preço por kg', todo: 'Ex.: PLA Basic, R$ 119,90/kg' },
  channel: { title: 'Um canal de venda', todo: 'Mercado Livre, Shopee ou Direto' },
} as const;
